/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { Button } from "@mui/material";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";

const DocumentDialogBottomActions = () => {
    
    const {
        handleChangeClose,
        selectedDocument,
        onChooseDocument,
        saveDocument,
        showSave,
    } = useContext(DocumentEditContext);
    
    const cancelDisabled = false;
    const saveDisabled = false;
    
    const handleChoose = () => {
        onChooseDocument(selectedDocument);
    };
    
    const handleSave = () => {
        saveDocument();
    };
    
    return (
        <div className="simplicity-image-selector-window-footer">
            
            {!showSave ? (
                <Button
                    variant='contained'
                    color='primary'
                    onClick={handleChoose}
                >
                    Select
                </Button>
            ) : (
                <Button
                    variant='contained'
                    color='primary'
                    onClick={handleSave}
                    disabled={saveDisabled}
                >
                    Save
                </Button>
            )}
            
            <Button
                variant='outlined'
                color='secondary'
                onClick={handleChangeClose}
                disabled={cancelDisabled}
            >
                Cancel
            </Button>
        
        </div>
    );
};

export { DocumentDialogBottomActions };
